import {Product} from "./product";
import {ProductBarcode} from "./productBarcode";

export class ProductMovement {

    id?: string;
    amount?: number;
    barcode: ProductBarcode[] = [];
    barcodeId: string | null | undefined = '';
    createdAt?: string;
    companyId: string = '';


    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.amount = raw.amount;
            this.barcode = raw.barcode;
            this.createdAt = raw.createdAt;
            this.barcodeId = raw.barcodeId;
            this.companyId = raw.companyId;
        }
    }
}
